// smtpModal.js
import React from "react";
import { Dialog } from "components/ui";
import IntegrationForm from "../Integrations/Smpt/index";

const SmtpModal = ({ isOpen, onClose, integrationId, onSaveSuccess }) => {
  return (
    <Dialog isOpen={isOpen} width="50%" onClose={onClose}>
      <IntegrationForm
        integrationId={integrationId}
        onClose={onClose}
        onSaveSuccess={onSaveSuccess}
      />
    </Dialog>
  );
};

export default SmtpModal; 
